export interface ManagedCaseActionState {
  status?: string;
  verificationOutcome?: string;
  whatsAppSenderNumber?: string | null;
  senderMismatch?: boolean;
  senderValidationPending?: boolean;
  followUpAllowed?: boolean;
}

export function isTerminalCustomerConfirmed(row: ManagedCaseActionState | null | undefined): boolean {
  return row?.verificationOutcome === 'CUSTOMER_CONFIRMED';
}

export function isTerminalVerification(row: ManagedCaseActionState | null | undefined): boolean {
  return isTerminalCustomerConfirmed(row) || row?.verificationOutcome === 'AUTO_CONFIRMED_TIMEOUT';
}

export function hasWhatsAppSender(row: ManagedCaseActionState | null | undefined): boolean {
  return !!row?.whatsAppSenderNumber && row.whatsAppSenderNumber.trim().length > 0;
}

export function followUpAvailable(row: ManagedCaseActionState | null | undefined): boolean {
  return !!row
    && row.followUpAllowed !== false
    && !isTerminalVerification(row)
    && row.status === 'READY_FOR_FOLLOWUP'
    && hasWhatsAppSender(row);
}

export function confirmAvailable(row: ManagedCaseActionState | null | undefined): boolean {
  return !!row
    && !isTerminalVerification(row)
    && row.status === 'READY_FOR_FOLLOWUP'
    && row.verificationOutcome !== 'PROBLEM_REPORTED'
    && row.verificationOutcome !== 'MANUAL_REVIEW'
    && !row.senderMismatch
    && !row.senderValidationPending;
}

export function nonTerminalOutcomesAvailable(row: ManagedCaseActionState | null | undefined): boolean {
  return !!row && !isTerminalVerification(row) && row.status === 'READY_FOR_FOLLOWUP';
}

export function manualReviewAvailable(row: ManagedCaseActionState | null | undefined): boolean {
  return !!row && !isTerminalVerification(row) && row.status !== 'CANCELLED';
}

export function readProgramResult(result: unknown): 'STANDARD' | 'TINYPROMO_MANAGED' | null {
  const value = typeof result === 'string'
    ? result.trim().replace(/^"|"$/g, '')
    : result && typeof result === 'object' && 'program' in (result as object)
      ? String((result as { program?: unknown }).program ?? '').trim()
      : '';
  if (value === 'STANDARD' || value === 'TINYPROMO_MANAGED') {
    return value;
  }
  return null;
}
